import React from 'react';
import { motion } from 'framer-motion';

function HeroMessage({ eyebrow, title, text, name }) {
  return (
    <motion.section
      className="hero-card"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      aria-labelledby="main-message"
    >
      <div className="hero-glow" aria-hidden="true" />
      <p className="eyebrow">{name ? `Hallo ${name} · ` : ''}{eyebrow}</p>
      <h1 id="main-message">{title}</h1>
      <p>{text}</p>
    </motion.section>
  );
}

export default HeroMessage;